import React, { createContext, useContext, useState, useCallback } from 'react';

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [isPollingEnabled, setIsPollingEnabled] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [timeUntilRefresh, setTimeUntilRefresh] = useState(15);

  const setRefreshing = useCallback(refreshing => {
    setIsRefreshing(refreshing);
  }, []);

  const togglePolling = useCallback(() => {
    setIsPollingEnabled(!isPollingEnabled);
  }, [isPollingEnabled]);

  const updateTimeUntilRefresh = useCallback(seconds => {
    setTimeUntilRefresh(seconds);
  }, []);

  const resetTimer = useCallback(() => {
    setTimeUntilRefresh(15);
  }, []);

  const value = {
    isPollingEnabled,
    isRefreshing,
    timeUntilRefresh,
    setRefreshing,
    togglePolling,
    updateTimeUntilRefresh,
    resetTimer,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
